export default "__VITE_ASSET__ef3933bb__"